<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="操作人" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入登录名"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="日志类型" prop="usertype">
            <el-select v-model="queryForm.usertype" clearable placeholder="请选择日志类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData" border default-expand-all stripe :header-cell-style="{'text-align':'center'}" style="width: 100%;margin-bottom: 20px;">
      <el-table-column prop="userName" label="操作人" />
      <el-table-column prop="goodsImgUrl" label="创建时间" />
      <el-table-column prop="goodsImgUrl" label="操作类型" />
      <el-table-column prop="goodsImgUrl" label="操作人IP" />
      <el-table-column prop="goodsImgUrl" label="操作信息" />
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "SystemMoneyOptLoglist",
  mixins:[MixinCUD],
  data() {
    return {
      tableData: [],
      queryForm: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
